module.exports = __webpack_public_path__ + "static/media/xing.de703404.svg";